import { QueryClient } from '@tanstack/react-query';
import { ApiResponseError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Försök igen 1 gång vid fel (inte vid 4xx)
      retry: (failureCount, error) => {
        if (error instanceof ApiResponseError && error.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
      // Cache i 5 minuter, stale efter 1 minut
      gcTime: 5 * 60 * 1000,
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
